import * as React from 'react';
import { connect } from 'react-redux';
import { ApplicationState } from '../../../store';
import { ToxnotComponent, ToxnotComponentProperties } from '../../core/BaseApplicationComponents/ToxnotComponent';
import { SftpImportConfigurationWorkflow, PostImportActionEnum, getPostImportActionDescriptions } from '../../../store/Models/Api/SftpImportModels';
import { RadioButtonGroup } from '../../core/RadioButtonGroup';

interface PostImportActionSectionLocalProps {
    configData: SftpImportConfigurationWorkflow;
    onConfigChange: (data: Partial<SftpImportConfigurationWorkflow>) => void;
}

type PostImportActionSectionProps = PostImportActionSectionLocalProps & ToxnotComponentProperties;

class PostImportActionSectionComponent extends ToxnotComponent<PostImportActionSectionProps> {
    public render() {
        const { configData, onConfigChange, appServices } = this.props;
        const postImportActionDescriptions = getPostImportActionDescriptions(appServices);

        return (
            <div className="group">
                <div className="title">{this.localizeString("Post-Import File Handling")}</div>
                <div className="content">
                    <RadioButtonGroup<PostImportActionEnum>
                        options={[
                            PostImportActionEnum.Skip,
                            PostImportActionEnum.Rename,
                            PostImportActionEnum.Archive,
                            PostImportActionEnum.Delete
                        ]}
                        value={configData.postImportAction}
                        onValueChange={(value) => onConfigChange({ postImportAction: value })}
                        getFriendlyNameForOptions={(option) => postImportActionDescriptions[option]}
                        name="post-import-action"
                    />
                </div>
            </div>
        );
    }
}

export const PostImportActionSection = connect(
    (state: ApplicationState) => ({ appServices: state.appServices! })
)(PostImportActionSectionComponent);
